import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  display: ", ";\n  justify-content: center;\n  align-items: center;\n  position: relative;\n  ", "\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';
import { ICON_SIZE } from '../../constants';
import { withOmitProps } from '../../helpers/elements';
import { size } from '../../style/size';
var IconWrapper = styled.span.withConfig(withOmitProps(['flex', 'pointer', 'disabled', 'inactive']))(_templateObject(), function (_ref) {
  var _ref$flex = _ref.flex,
      flex = _ref$flex === void 0 ? true : _ref$flex;
  return flex ? 'inline-flex' : 'inline-block';
}, function (_ref2) {
  var pointer = _ref2.pointer,
      disabled = _ref2.disabled,
      inactive = _ref2.inactive;
  return pointer && (!disabled || !inactive) && "cursor: pointer;";
}, size(ICON_SIZE));
export default IconWrapper;